module.exports = __webpack_public_path__ + "static/media/homeVideos.307640a4.jpg";